import React from 'react';
import HicetnuncContext from '~/contexts/Hicetnunc/__Context';

// @ts-ignore
const useHicetnuncContext = () => React.useContext(HicetnuncContext);

export default useHicetnuncContext;
